// extracted by mini-css-extract-plugin
export default {"container":"external_form_modal_container__Wsck-","buttonGroup":"external_form_modal_buttonGroup__vzifu","supportText":"external_form_modal_supportText__-UzVy"};